import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessStore = {
  state: {
    businesses: [],
    business: {},
    businessServices: []
  },
  getters,
  mutations,
  actions
}

export default BusinessStore